import React from "react";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-scroll";
import "./AppBar.css";
import CloseIcon from "@mui/icons-material/Close";
import {
  componentSelectedSliceValue,
  updateComponentName,
} from "../app/slice/componentSelectedSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import WorkIcon from "@mui/icons-material/Work";
import CallIcon from "@mui/icons-material/Call";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { useNavigate } from "react-router-dom";

var Scroll = require("react-scroll");
var Element = Scroll.Element;
var scroller = Scroll.scroller;

export const StyledMenuButton = styled(Button)({
  backgroundColor: "transparent",
  width: "10px",
  display: "block",
  padding: " 10px 10px",
  textAlign: "center",
  left: 0,
  top: 0,
  transition: "all 0.5s ease",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: "grey",
  },
  "&:visited": {
    color: "white",
  },
});

const pagesWithIcons = [
  {
    menuIcon: (
      <RemoveRedEyeIcon
        sx={{
          color: "#5cb5b3",
        }}
      />
    ),
    menuName: "About",
  },
  {
    menuIcon: (
      <PhoneAndroidIcon
        sx={{
          color: "#5cb5b3",
        }}
      />
    ),
    menuName: "Product",
  },
  {
    menuIcon: (
      <WorkIcon
        sx={{
          color: "#5cb5b3",
        }}
      />
    ),
    menuName: "Careers",
  },
  {
    menuIcon: (
      <CallIcon
        sx={{
          color: "#5cb5b3",
        }}
      />
    ),
    menuName: "Contact",
  },
];

export default function CustomAppBar(props) {
  const isMobile = useMediaQuery("(max-width: 770px)");
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const dispatch = useDispatch();

    //to know what component was clicked and handle UI change on scroll (HomePage.js)
    let component = useSelector(componentSelectedSliceValue);

  
  const handleCloseNavMenu = (page) => {
if(component?.value === 'help'){
  navigate(
    `/`
);

setTimeout(function () {
  navigation(page)
  //3600000 1 hr
}, 500);




}else{
    if (page === "About") {
      dispatch(updateComponentName({ value: "vision" }));
      scroller.scrollTo("vision", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 15, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Product") {
      dispatch(updateComponentName({ value: "product" }));
      scroller.scrollTo("product", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Careers") {
      dispatch(updateComponentName({ value: "careers" }));
      scroller.scrollTo("careers", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Contact") {
      dispatch(updateComponentName({ value: "contact" }));
      scroller.scrollTo("contact", {
        duration: 1500,
        delay: 100,
        smooth: true,
        isDynamic: true,
        // containerId: 'ContainerElementID',
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "home") {
      dispatch(updateComponentName({ value: "home" }));
      scroller.scrollTo("home", {
        duration: 1500,
        delay: 100,
        smooth: true,
        // containerId: 'ContainerElementID',
        offset: -100, // Scrolls to element + 50 pixels down the page
      });
    } else {
      //do nothing
    }

}

    setAnchorElNav(null);
  };

  const navigation = (page)=>{
    if (page === "About") {
      dispatch(updateComponentName({ value: "vision" }));
      scroller.scrollTo("vision", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 15, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Product") {
      dispatch(updateComponentName({ value: "product" }));
      scroller.scrollTo("product", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Careers") {
      dispatch(updateComponentName({ value: "careers" }));
      scroller.scrollTo("careers", {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "Contact") {
      dispatch(updateComponentName({ value: "contact" }));
      scroller.scrollTo("contact", {
        duration: 1500,
        delay: 100,
        smooth: true,
        isDynamic: true,
        // containerId: 'ContainerElementID',
        offset: 50, // Scrolls to element + 50 pixels down the page
      });
    } else if (page === "home") {
      dispatch(updateComponentName({ value: "home" }));
      scroller.scrollTo("home", {
        duration: 1500,
        delay: 100,
        smooth: true,
        // containerId: 'ContainerElementID',
        offset: -100, // Scrolls to element + 50 pixels down the page
      });
    } else {
      //do nothing
    }

  }


  const login = () => {
    //login to 7day site
    // navigate("https://app.7-day.com/login");
    window.location.href = "https://app.7-day.com/login";
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          backgroundColor: "transparent",
          border: "none",
          width: "100%",
          position: "fixed",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            backgroundColor:
              component?.value === "home"
                ? "none"
                : isMobile
                ? "#5cb5b3"
                : "#fff",
          }}
        >
          <Box
            sx={{
              // HIDE LOGO IF SCREEN XS
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              width: "auto",
            }}
          >
            <Link
              to={"home"}
              spy={true}
              smooth={true}
              offset={100}
              duration={2000}
              delay={350}
            >
              <Typography
                variant="h1"
                noWrap
                component="a"
                sx={{
                  mr: 2,
                  display: { xs: "none", md: "flex" },
                  fontSize: 40,
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: component?.value?.includes("home")
                    ? "white"
                    : "#787878",
                  textDecoration: "none",
                  paddingLeft: "30px",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                7DAY
              </Typography>
            </Link>
          </Box>
          {/* 
                MOBILE RESPONSIVE */}
          <Box
            sx={{
              // flexGrow:1,
              width: "auto",
              display: { xs: "flex", md: "none" },
              // backgroundColor: 'green',
            }}
          >
            <IconButton
              size="large"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon sx={{ color: "#fff" }} />
            </IconButton>

            <Menu
              anchorEl={anchorElNav}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  marginTop: "-15px",
                  marginLeft: isMobile ? "-15px" : "-15px",
                  width: isMobile ? "auto" : "50%",
                  height: isMobile ? "100%" : "110%",
                },
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              <MenuItem
                // disableRipple
                sx={{
                  fontFamily: "Open Sans",
                  textAlign: "right",
                  justifyContent: "right",

                  "&:hover": {
                    cursor: "pointer",
                    color: "#fff",
                    backgroundColor: "#fff",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                  }}
                >
                  <IconButton
                    aria-label="close"
                    aria-haspopup="true"
                    onClick={() => handleCloseNavMenu("close")}
                    sx={{
                      "&:hover": {
                        cursor: "pointer",
                        color: "#5cb5b3",
                        backgroundColor: "rgba(92, 181, 179, 0.1) ",
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Typography>
              </MenuItem>

              <Grid>
                {pagesWithIcons.map((page) => (
                  <MenuItem
                    disableRipple
                    key={page.menuName}
                    onClick={() => handleCloseNavMenu(page.menuName)}
                    sx={{
                      width: "auto",
                      height: "60px",
                      // backgroundColor: 'red',
                      color: "#787878",
                      display: "flex",
                      flexDirection: "row",
                      "&:hover": {
                        cursor: "pointer",
                        color: "#5cb5b3",
                        backgroundColor: "rgba(92, 181, 179, 0.1) ",
                        // transition: '1s all ease-in-out',
                      },
                    }}
                  >
                    <Grid
                      sx={{
                        // backgroundColor: 'yellow',
                        width: "10%",
                        // height: '100%',
                      }}
                    >
                      <Typography
                        textAlign="left"
                        justifyContent="center"
                        sx={{
                          fontFamily: "Open Sans",
                          paddingTop: "5px",
                          // backgroundColor: 'red',
                          // color: '#fff',
                          // borderRadius: '80%'
                        }}
                      >
                        {page.menuIcon}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        // backgroundColor: 'green',
                        width: "90%",
                        // height: '100%',
                      }}
                    >
                      <Typography
                        textAlign="left"
                        sx={{
                          fontFamily: "Open Sans",
                        }}
                      >
                        {page.menuName}
                      </Typography>
                    </Grid>
                  </MenuItem>
                ))}
              </Grid>

              <Divider flexItem />
              <Grid
                sx={{
                  width: "auto",
                  height: "100%",
                  textAlign: "center",
                }}
              >
                <Grid sx={{ padding: "100px" }}>
                  <img
                    alt="primarylogo"
                    src="/logos/GreenLogoNoBack.png"
                    style={{
                      // height: '50px',
                      // width: '140px',
                      height: "45px",
                    }}
                  />{" "}
                </Grid>{" "}
              </Grid>
            </Menu>
          </Box>
          <Box
            sx={{
              width: "66.66%",
              display: { xs: "flex", md: "none" },
              // justifyContent: 'left',
              // backgroundColor: 'red',
            }}
          >
            {" "}
            <Link
              to={"home"}
              spy={true}
              smooth={true}
              offset={100}
              duration={2000}
              delay={350}
            >
              <Typography
                variant="h1"
                noWrap
                component="a"
                sx={{
                  fontSize: 20,
                  fontFamily: "Open Sans",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "white",
                  textDecoration: "none",
                  // paddingLeft: '30px',
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                7DAY
              </Typography>
            </Link>
          </Box>

          {/* 
                DESKTOP RESPONSIVE */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              // alignItems: 'center',
            }}
          >
            <Grid>
              {" "}
              {pagesWithIcons.map((page) => (
                <Button
                  disableRipple
                  key={page.menuName}
                  onClick={() => handleCloseNavMenu(page.menuName)}
                  sx={{
                    fontFamily: "Open Sans",
                    color: component?.value?.includes("home")
                      ? "white"
                      : "#787878",
                    letterSpacing: ".1rem",
                    "&:hover": {
                      cursor: "pointer",
                      color: component?.value?.includes("home")
                        ? "#5cb5b3"
                        : "#fff",
                      backgroundColor: component?.value?.includes("home")
                        ? "white"
                        : "#5cb5b3",
                    },
                  }}
                >
                  {page.menuName}
                </Button>
              ))}
            </Grid>
          </Box>

          {/* LOGIN TO APP*/}
          <Box
            sx={{
              display: "flex",
              width: "33.33%",
              justifyContent: " flex-end",
              alignItems: "flex-end",
              alignContent: "flex-end",
            }}
          >
            {" "}
            <Grid
              sx={{
                display: { xs: "flex", md: "flex" },
                width: "fit-content",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingRight: isMobile ? "5px" : "15px",
                // backgroundColor: 'yellow'
              }}
            >
              <>
                <Button
                  // disableRipple
                  onClick={login}
                  sx={{
                    fontFamily: "Open Sans",
                    color: component?.value?.includes("home")
                      ? "#5cb5b3"
                      : "#fff",
                    backgroundColor: component?.value?.includes("home")
                      ? "#fff"
                      : "#5cb5b3",
                    letterSpacing: ".1rem",
                    "&:hover": {
                      cursor: "pointer",
                      color: component?.value?.includes("home")
                        ? "#5cb5b3"
                        : "#fff",
                      backgroundColor: component?.value?.includes("home")
                        ? "rgba(255,255,255, 0.8)"
                        : "rgba(92,181,179, 0.8)",
                    },
                  }}
                >
                  {isMobile ? "Sign In " : "Sign in to 7DAY"}
                </Button>
              </>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
